export enum WholeSalePaymentType {
    Fiscal = 0,
    Invoice = 1,
    ProInvoice = 2,
    Reserve = 3,
    DeliveryNote = 4,
    Debt = 5,
    Cancel = 6,
    Save = 7
}